module.exports = __webpack_public_path__ + "static/img/PublicCode.fdf965c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/image/PublicCode.jpg
// module id = SOER
// module chunks = 1